<template>
  <div class="referrals-collect">
    <div class="vx-row">
      <div class="vx-col w-full lg:w-2/3">
        <vx-card title="Add a referral by hand">
          <p class="mb-4 text-sm" style="color:#888">
            For word-of-mouth walk-ins. {{ hasFriendReward ? "We'll email the friend their welcome reward code right away." : "We'll email the friend a welcome note right away." }}
          </p>

          <div v-if="programOff" class="mb-4 p-3" style="background:#fff4e5;border-radius:6px;color:#b26a00;font-size:13px">
            Your referral program is currently <strong>off</strong>. You can still add referrals,
            but <template v-if="!$store.getters['dash/isCollaborator']">turn it on under <router-link to="/dash/settings/referrals" class="font-semibold">Settings &rsaquo; Referrals</router-link></template><template v-else>ask the account owner to turn it on</template>
            so referrals are tracked.
          </div>

          <div class="mb-3">
            <label class="vs-input--label">Referrer (your existing customer)</label>
            <vs-input class="w-full mb-2" v-model="addForm.referrerName" placeholder="Referrer name" />
            <vs-input class="w-full" v-model="addForm.referrerEmail" placeholder="Referrer email (optional)" />
          </div>
          <div class="mb-4">
            <label class="vs-input--label">Friend (the new person)</label>
            <vs-input class="w-full mb-2" v-model="addForm.friendName" placeholder="Friend name" />
            <vs-input class="w-full mb-2" v-model="addForm.friendEmail" placeholder="Friend email" />
            <vs-input class="w-full" v-model="addForm.friendPhone" placeholder="Friend phone" type="tel" />
          </div>
          <vs-button :disabled="addingReferral" @click="submitReferral">
            <span v-if="addingReferral" class="btn-spin mr-2"></span>{{ addingReferral ? 'Adding…' : (hasFriendReward ? 'Add & send welcome reward' : 'Add & send welcome email') }}
          </vs-button>

          <p class="mt-4 text-sm" style="color:#aaa">
            Added referrals show up in the <strong>Referrals</strong> tab.
          </p>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import referralsMixin from './referralsMixin.js'

export default {
  mixins: [referralsMixin],
  data () {
    return {
      addForm: {
        referrerName: '',
        referrerEmail: '',
        friendName: '',
        friendEmail: '',
        friendPhone: ''
      },
      addingReferral: false,
      programOff: false,
      //assume a reward until settings load — most programs have one, and the reward-less
      //wording must never flash for them while the fetch is in flight
      hasFriendReward: true
    }
  },
  methods: {
    checkProgramState () {
      this.$store.dispatch('dash/FETCH_REFERRALS').then((res) => {
        if (res && res.referralSettings) {
          this.programOff = !res.referralSettings.enabled
          this.hasFriendReward = typeof res.referralSettings.friendReward === 'string'
            && res.referralSettings.friendReward.trim() !== ''
        }
      }).catch(() => {})
    },
    submitReferral () {
      if (!this.addForm.friendEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.addForm.friendEmail)) {
        this.notifyError('Please enter a valid friend email')
        return
      }
      if ((this.addForm.friendPhone || '').replace(/[^0-9]/g, '').length < 7) {
        this.notifyError('Please enter a valid friend phone number')
        return
      }
      this.addingReferral = true
      const clientRequestId = 'cr_' + Date.now() + '_' + Math.floor(Math.random() * 1e6)
      this.$store.dispatch('dash/CREATE_REFERRAL', {
        referrerName: this.addForm.referrerName,
        referrerEmail: this.addForm.referrerEmail,
        friendName: this.addForm.friendName,
        friendEmail: this.addForm.friendEmail,
        friendPhone: this.addForm.friendPhone,
        clientRequestId
      }).then((res) => {
        this.addingReferral = false
        if (res && res.alreadyCreated) {
          this.notifySuccess('This referral was already added — no duplicate was created')
        } else if (res && res.emailSent) {
          this.notifySuccess(this.hasFriendReward ? 'Referral added — welcome reward emailed' : 'Referral added — welcome email sent')
        } else {
          // referral + code exist, but the invite email didn't go out — give staff the code
          this.notifyWarning(`Referral added, but the welcome email could not be sent.${res && res.friendCode ? ` Give the friend their code directly: ${res.friendCode}` : ''}`)
        }
        this.addForm = { referrerName: '', referrerEmail: '', friendName: '', friendEmail: '', friendPhone: '' }
        //the Referrals tab's table is stale now — let the parent refresh it
        this.$emit('referraladded')
      }).catch((e) => {
        this.addingReferral = false
        this.notifyError(this.referralErrorText(e, 'Could not add the referral'))
      })
    }
  },
  created () {
    this.checkProgramState()
  }
}
</script>

<style scoped>
.referrals-collect .vs-input--label {
  display: block;
  margin-bottom: 4px;
  font-size: 13px;
  color: #666;
}
.btn-spin {
  display: inline-block;
  width: 0.9em;
  height: 0.9em;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: currentColor;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
  vertical-align: middle;
}
</style>
